import { Component, Input, ViewChild, ElementRef, Output, EventEmitter } from '@angular/core';
import { FormControl } from '@angular/forms';
// Services';
import { FormService } from '../../../../services/form.service';
import { LoggerService, BroadcastService } from '@cv-invision/core';

@Component({
	selector: 'cv-review-fields-input',
	templateUrl: './input-field.component.html',
	styleUrls: ['./input-field.component.scss']
})
export class InputFieldComponent {
	@Input() fieldOptions: any;
	@Input() control: FormControl;
	@Input() field: any;
	@Input() value: any;
	@Input() historical: Array<any>;
	@Input() show: any;
	@Input() active = false;
	@Output() openHistorical: EventEmitter<any> = new EventEmitter<any>();

	@ViewChild('changesEl', { read: ElementRef, static: false }) changesEl: ElementRef;

	get module(): any {
		return true;
	}

	highlight = '';

	constructor(
		private broadcastService: BroadcastService,
		private formService: FormService,
		private console: LoggerService
	) { }

	/**
	 * validates form on input blur
	 * @param event 
	 */
	async onChange(event: any): Promise<void> {
		if (this.control.parent) {
			if (
				(this.field.DataType === 'Text' || this.field.DataType === 'String')
				&& this.control.value !== this.control.value.trim()
			) {
				this.control.setValue(this.control.value.trim());
			}

			if (this.control.dirty || this.field.DataType === 'Enumerated') {
				this.formService.validate(this.control.parent);
				await this.formService.update();
			}
		}
	}

	/**
	 * validates form on input keyup
	 * @param event 
	 */
	async onKeyup(event: any): Promise<void> {
		if (this.control.parent) {
			if (this.control.dirty) {
				this.formService.validate(this.control.parent);
				await this.formService.update();
			}
		}
	}

	/**
	 * Cascader select update
	 * @param event 
	 */
	cascadeChanged(event: any): void {
		// this.console.log(this.removeExcludesFromEnums);
		if (this.control.value !== event.Key) {
			this.control.setValue(event.Key);
			this.onChange(event);
		}
	}

	/**
	 * open historical component
	 * @param item
	 * @param historical
	 */
	showHistorical(): void {
		this.openHistorical.emit(this.changesEl);
	}

}
